import Vue from "vue";
import Router from "vue-router";

import quizSection from "@/components/quiz/QuizSection.vue";

Vue.use(Router);


export default new Router({
    routes: [
        {
            path: "/",
            name: "homePage",
            component: () => import('@/components/home/HomePage')
        },
        {
            path: "/passed",
            name: "quizPassed",
            component: () => import('@/components/home/QuizPassed')
        },
        {
          path: "/quiz/:slug",
          name: "quizSection",
          component: quizSection,
        },
        {
          path: '/complete',
          name: 'completePage',
          component: () => import('@/components/complete/CompletePage'),
        },
        {
            path: '*',
            name: 'errorPage',
            component: () => import('@/components/error/ErrorPage'),
        },
    ],

    scrollBehavior () {
        return { x: 0, y: 0 }
    }      
},
)